import { type APIError } from "@/type/api";

async function MessageForResponse(resp: Response): Promise<string> {
	if (resp.status == 400) {
		const data: APIError = (await resp.json()) as APIError;
		if (data.message == "empty-address") {
			return "You must provide either an address, or a location on the map, otherwise we don't have much to work with.";
		} else if (data.message == "geocode-raw") {
			return `The address you've provided is ambiguous. Please either select the location on the map, select a suggestion from the list, or add more specifics to the address.`;
		}
	}
	return "Something went wrong. Your request could not be completed. Please try again.";
}
export default {
	MessageForResponse,
};
